var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgLink2 = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8085 8.40426C14.4207 8.40426 14.1064 8.0899 14.1064 7.70213C14.1064 7.31435 14.4207 7 14.8085 7H17.617C19.0447 7 20.4139 7.56713 21.4234 8.57664C22.4329 9.58614 23 10.9553 23 12.383C23 15.3559 20.59 17.766 17.617 17.766H14.8085C14.4207 17.766 14.1064 17.4516 14.1064 17.0638C14.1064 16.6761 14.4207 16.3617 14.8085 16.3617H17.617C19.8144 16.3617 21.5957 14.5804 21.5957 12.383C21.5957 11.3278 21.1766 10.3158 20.4304 9.5696C19.6842 8.82344 18.6722 8.40426 17.617 8.40426H14.8085ZM9.19149 16.3617C9.57926 16.3617 9.89362 16.6761 9.89362 17.0638C9.89362 17.4516 9.57926 17.766 9.19149 17.766H6.38298C4.95532 17.766 3.58614 17.1988 2.57664 16.1893C1.56713 15.1798 1 13.8106 1 12.383C1 9.41004 3.41004 7 6.38298 7H9.19149C9.57926 7 9.89362 7.31435 9.89362 7.70213C9.89362 8.0899 9.57926 8.40426 9.19149 8.40426H6.38298C4.18559 8.40426 2.40426 10.1856 2.40426 12.383C2.40426 13.4382 2.82344 14.4502 3.5696 15.1964C4.31575 15.9425 5.32776 16.3617 6.38298 16.3617H9.19149ZM8.25532 13.0851C7.86754 13.0851 7.55319 12.7708 7.55319 12.383C7.55319 11.9952 7.86754 11.6809 8.25532 11.6809H15.7447C16.1325 11.6809 16.4468 11.9952 16.4468 12.383C16.4468 12.7708 16.1325 13.0851 15.7447 13.0851H8.25532Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgLink2;